import { type FC } from 'react';

import { Divider } from '@craft/ui/components/structural';

export const NavDivider: FC = () => (
  <Divider sx={t => ({ marginY: t.spacing(0.5) })} variant='middle' />
);
